module.exports = __webpack_public_path__ + "img/dsci0140.4185cbea.jpg";